(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('KnowledgeBaseController', knowledgeBaseController);

  knowledgeBaseController.$inject = ['ngTableParams', 'KnowledgeBaseService', 'NotificationService', 'KnowledgeBaseTagService', 'CompanyService', 'FoundationApi', 'UtilsService', 'LangService'];

  function knowledgeBaseController (ngTableParams, KnowledgeBaseService, NotificationService, KnowledgeBaseTagService, CompanyService, FoundationApi, UtilsService, LangService) {
    var vm = this;

    vm.baseUrl = baseUrl;
    vm.knowledgeBase = {};
    vm.removedTags = [];
    vm.addedTags = [];
    vm.tags_auto_complete = {};
    vm.createTags = [];
    vm.readOnly = false;
    vm.new_tag = {}
    vm.removeTag = {};

    vm.labels = '';

    LangService
      .getPageLabels({ 'page': 'menu.knowledgebase' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

    vm.save = function () {

      if (vm.knowledgeBase.title == '' || vm.knowledgeBase.title == undefined) {
        NotificationService.errorHandler(null, vm.labels.titleRequired);
        return;
      }

      if (vm.knowledgeBase.title.length > 255) {
        NotificationService.errorHandler(null, vm.labels.titleMaxLength)
        return;
      }

      if (vm.knowledgeBase.text === '' || vm.knowledgeBase.text === undefined) {
        NotificationService.errorHandler(null, vm.labels.textRequired)
        return
      }

      if (!vm.form.knowledgebaseForm.$valid) {
        NotificationService.errorHandler(null, vm.labels.tagError)
        return
      }

      if (!vm.knowledgeBase.id) {
        KnowledgeBaseService
          .save(vm.knowledgeBase)
          .$promise
          .then(function (data) {
            FoundationApi.publish('knowledgebaseCreate', 'close');
            vm.form.knowledgebaseForm.$setPristine();
            NotificationService.successHandler(data, vm.labels.saveKnowledgeBaseSuccessfull);
            vm.knowledgeBaseTable.reload();
            delete vm.knowledgeBase;
            loadTags();
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, vm.labels.knowledgeBaseErrorLoading);
          });
      } else {
        KnowledgeBaseService
          .update(vm.knowledgeBase)
          .$promise
          .then(function (data) {
            NotificationService.successHandler(data, vm.labels.saveKnowledgeBaseSuccessfull);
            vm.form.knowledgebaseForm.$setPristine();
            vm.knowledgeBaseTable.reload();
            delete vm.knowledgeBase;
            loadTags();
            FoundationApi.publish('knowledgebaseView', 'close');
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, vm.labels.knowledgeBaseErrorLoading);
          });
      }
    }

    vm.delete = function (id) {
      KnowledgeBaseService
        .delete({ id: id })
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, vm.labels.removeKnowledgeBaseSuccessfull);
          FoundationApi.publish('confirmDeleteModal', 'close');
          vm.knowledgeBaseTable.reload();
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.removeKnowledgeBaseError)
        })
    }

    vm.destroyTag = function (tag) {
      vm.blockBtn = true;
      KnowledgeBaseTagService
        .delete(tag)
        .$promise
        .then(function (data) {
          vm.blockBtn = false;
          NotificationService.successHandler(data, vm.labels.removeTagSuccessfull.replace('#TAG#', tag.tag.toUpperCase()));
          FoundationApi.publish('dialogModal', 'close');
          loadTags();
        })
        .catch(function (error) {
          vm.blockBtn = false;
          FoundationApi.publish('dialogModal', 'close');
          NotificationService.errorHandler(error, vm.labels.removeTagError);
        });
    }

    vm.addTag = function (tag) {
      KnowledgeBaseTagService
        .create(tag)
        .$promise
        .then(function (data) {
          vm.new_tag = { id: data.id, tag: data.tag };
          vm.tags_auto_complete.push(angular.copy(vm.new_tag));
          NotificationService.successHandler(data, vm.labels.addTagSuccessfull.replace('#TAG', data.tag.toUpperCase()));
          delete vm.createTags;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.addTagError);
        });
    }

    vm.knowledgeBaseViewDetails = function (knowledgebase) {
      CompanyService
        .loadMetadata()
        .$promise
        .then(function (data) {
          vm.readOnly = true;
          vm.knowledgeBase = knowledgebase;
          vm.knowledgeBase.text = UtilsService.jsonParseText(vm.knowledgeBase.text);
          FoundationApi.publish('knowledgebaseView', 'open');
        })
    }

    vm.knowledgeBaseEditDetails = function (knowledgebase) {
      CompanyService
        .loadMetadata()
        .$promise
        .then(function (data) {
          vm.readOnly = false;
          vm.knowledgeBase = knowledgebase;
          vm.knowledgeBase.text = UtilsService.jsonParseText(vm.knowledgeBase.text);
          FoundationApi.publish('knowledgebaseView', 'open');
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.loadingMetadataError);
        });
    }

    vm.createKnowledgebaseTag = function (knowledgebase) {
      CompanyService
        .loadMetadata()
        .$promise
        .then(function (data) {
          vm.knowledgeBase = {};
          FoundationApi.publish('knowledgebaseTags', 'open');
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.loadingMetadataError);
        });
    }

    vm.deleteTag = function (tag) {
      vm.removeTag = tag;
      FoundationApi.publish('dialogModal', 'open');
    }

    vm.createKnowledgebase = function () {
      CompanyService
        .loadMetadata()
        .$promise
        .then(function (data) {
          vm.knowledgeBase = {};
          FoundationApi.publish('knowledgebaseCreate', 'open');
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.loadingMetadataError);
        });
    }

    vm.closeKnowledgebase = function (knowledgebaseView) {
      FoundationApi.publish(knowledgebaseView, 'close');
      vm.knowledgeBaseTable.reload();
      vm.knowledgeBase = {};
    }

    vm.confirm = function (knowledgebase) {
      CompanyService
        .loadMetadata()
        .$promise
        .then(function (data) {
          vm.knowledgeBase = knowledgebase;
          FoundationApi.publish('confirmDeleteModal', 'open');
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.loadingMetadataError);
        })
    }

    vm.search = function (term) {
      var promise = KnowledgeBaseTagService.searchTag({ id: null, term: term }).$promise;
      promise.then(function (data) {
        return data;
      });
      promise.catch(function (error) {
        NotificationService.errorHandler(error, vm.labels.loadingTagError);
      });
      return promise;
    }

    vm.showKnowledgeBaseText = function (text) {
      return UtilsService.jsonParseText(text);
    }

    vm.filters = {
      status_id: 'all',
      number: ''
    };

    vm.knowledgeBaseTable = new ngTableParams(
      {
        page: 1,
        count: 8,
        sorting: {}
      },
      {
        counts: [4, 6, 16],
        getData: function ($defer, params) {
          var obj = params.url();
          var keys = Object.keys(vm.filters);
          for (var i = 0; i < keys.length; i++) {
            var filterValue = vm.filters[keys[i]];
            if (filterValue != null && filterValue !== '') {
              obj['filter[' + keys[i] + ']'] = filterValue;
            }
          }
          KnowledgeBaseService
            .paged(obj)
            .$promise
            .then(function (data) {
              params.total(data.total);
              $defer.resolve(data.data);
              vm.totalData = data.total;
            })
            .catch(function (error) {
              NotificationService.errorHandler(error, vm.labels.knowledgeBaseErrorLoading);
            });
        }
      }
    );

    function loadTags () {
      KnowledgeBaseTagService
        .all()
        .$promise
        .then(function (data) {
          vm.tags_auto_complete = data;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vm.labels.loadingTagError);
        });
    }

    loadTags();
  }
})();
